import { PoolTokenType, hrAmms, V2_FACTORIES, hrFarms } from "impermax-sdk";
import React from "react";
import useFactory from "../../hooks/useFactory";
import useGenericCall from "../../hooks/useGenericCall";
import { useGetBlacklisted, useGetWhitelistedOld } from "../../hooks/useNetwork";
import usePairAddress from "../../hooks/usePairAddress";
import { useOffchainLendingPool } from "../../hooks/useOffchain";
import { useTokenIcon } from "../../hooks/useUrlGenerator";
import "./index.scss"

export default function PairLeftTitle() {
  const factory = useFactory();
  const pairAddress = usePairAddress();
  const data = useGenericCall(useOffchainLendingPool(), async offchainLendingPool => ({
    amm: await offchainLendingPool.getAmm(),
    farm: await offchainLendingPool.getFarm(),
    symbolA: await offchainLendingPool.getBorrowableA().getSymbol(),
    symbolB: await offchainLendingPool.getBorrowableB().getSymbol(),
  }));
  const tokenIconA = useTokenIcon(PoolTokenType.BorrowableA);
  const tokenIconB = useTokenIcon(PoolTokenType.BorrowableB);
  const getWhitelistedOld = useGetWhitelistedOld();
  const getBlacklisted = useGetBlacklisted();
  
  if (!data) return null;

  return (
    <div className="pair-left-title">
      <div className="currency-overlapped">
        <img src={tokenIconA} />
        <img src={tokenIconB} />
      </div>
      <div className="title">
        <span className="symbols">{data.symbolA}/{data.symbolB}</span><br/>
        <span className={"amm-label " + data.amm}>{hrAmms[data.amm]}</span>
        {V2_FACTORIES.includes(factory) && (
          <span className="farm-label new">{
            hrFarms[data.farm] && hrFarms[data.farm].includes("Stable") ? "Stable" : "V2"
          }</span>
        )}
        {
          getWhitelistedOld(factory).includes(pairAddress) ? (
            <span className={"farm-label deprecated"}>Deprecated</span>
          ) : 
          getBlacklisted(factory).includes(pairAddress) ? (
            <span className={"farm-label blacklisted"}>Blacklisted</span>
          ) : null
          // hrFarms[data.farm] && !hrFarms[data.farm].includes("Stable") && hrFarms[data.farm] != hrAmms[data.amm] && (
          //   <span className={"farm-label " + data.farm}>{hrFarms[data.farm]}</span>
          // )
        }
      </div>
    </div>
  );
}
